import React from "react";
import "./style.css";
import loaderGif from "../assets/loader.gif"
export default function Loader() {
    return (
        <div className="loading_overlay">
            <img src={loaderGif} alt="" />
        </div>
    )
}